import React, { useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Login from "./Login";
import Admin from "./Admin";
import NoMatch from "./NoMatch";
import "./App.css";

const theme = createTheme({
	palette: {
		primary: {
			main: "#35284A",
		},
		secondary: {
			main: "#FB7D79",
		},
		custom: {
			main: "#E6E1F4",
			100: "#F5F2F9",
			light: "#fff",
			dark: "#000",
			grey: "#dedede",
		},
		light: {
			main: "#fff",
		},
		dark: {
			main: "#000",
			100: "#222222",
		},
	},
	typography: {
		fontFamily: "Iran Sans",
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 900,
			lg: 1200,
			xl: 1536,
		},
	},
	components: {
		MuiTableCell: {
			styleOverrides: {
				root: {
					textAlign: "center !important",
					fontSize: 15,
					border: "1px solid rgba(0,0,0,0.1)",
				},
			},
		},
	},
	direction: "rtl",
});

function App() {
	const [isAuth, setAuth] = useState(false);
	return (
		<ThemeProvider theme={theme}>
			<Switch>
				<Route
					component={() => <Login setAuth={setAuth} />}
					path="/school/"
					exact
				/>
				<PrivateRoute
					path="/school/admin"
					auth={isAuth}
					component={() => <Admin setAuth={setAuth} />}
				/>
				<Route component={NoMatch} />
			</Switch>
		</ThemeProvider>
	);
}

export default App;
